import React, { Component } from 'react'
import { StatusAlertService } from 'react-status-alert'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import MessageCreateUI from './MessageCreateUI'

class MessageCreateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      html: null,
      submitted: false,
      userIdList: this.props.messageUserList.map(user => user.userId),
    }
    this.taskId = this.props.task.taskId // used to avoid multiple fetches in componentWillReceiveProps
  }

  render() {
    return (
      <MessageCreateUI
        context={this.props.context}
        messageList={this.props.messageList}
        // html
        html={this.state.html}
        onHtmlChange={this.onHtmlChange}
        // users
        userIdList={this.state.userIdList}
        onUsersChange={this.onUsersChange}
        projectUserList={this.props.projectUserList}
        messageUserList={this.props.messageUserList}
        // form
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
        submitted={this.state.submitted}
      />
    )
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.task && props.task.taskId !== this.taskId) {
      this.taskId = props.task.taskId
      let userIdList = props.messageUserList.map(user => user.userId)
      this.setState({submitted: false, html: null, userIdList: userIdList})
    }
  }

  onSubmit = () => {
    if (!this.state.html)
      return
    this.setState({submitted: true})
    RestApiUtils.post(this.props.context,
      `/api/tasks/${this.props.task.taskId}/messages`,
      this.createMessageCallback, {
        message: this.state.html,
        userIdList: this.state.userIdList
      }
    )
  }

  createMessageCallback = response => {
    this.setState({submitted: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    this.setState({html: null})
    let taskMessageList = this.props.taskMessageList
    taskMessageList.push(response.taskMessage)
    this.props.onMessageListUpdate(taskMessageList)

    CacheManager.removeObject(CacheKeys.TaskMessages(this.props.task.taskId))
    CacheManager.removeObject(CacheKeys.TaskMessageUsers(this.props.task.taskId))
  }

  handleError(errorList) {
    errorList.forEach(error => {
      if (error.errorCode === 'NotFound' && error.objectCode === 'Task')
        this.props.onForceTaskListRefresh(this.props.task.projectId)
    })
    StatusAlertService.showError(errorList[0].message, {withCloseIcon: false})
  }

  onHtmlChange = (html) => {
    this.setState({html: html})
  }

  onUsersChange = (userIdList) => {
    this.setState({userIdList: userIdList})
  }

  onCancel = () => {
    this.setState({html: null})
  }
}

export default MessageCreateSF
